import Nullstack from 'nullstack';
export default function IconLogicNor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-logic-nor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M2 9h5"
  }), "   ", Nullstack.element("path", {
    d: "M2 15h5"
  }), "   ", Nullstack.element("path", {
    d: "M6 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "12",
    r: "2"
  }), " ");
}